// extracted by mini-css-extract-plugin
export default {"wrapper":"cC-z","viewport":"dC-z","container":"eC-z","slide":"fC-z"};